import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateCreditSelectAction } from '../../../redux/actions/creditRating';
import { getBestOfferActionFromState, resetTermMileage, initialRenderReset } from '../../../redux/actions/bestOffers';
import { get, geti18n } from '../../../utils'
import SelectBox from '../../SelectBox';
import BBTextLink from '../../../components/TextLink/BBTextLink';
import TextLink from '../../../components/TextLink';

class CreditRatingSelect extends Component {
  static propTypes = {
    label: PropTypes.string,
    items: PropTypes.array,
    select: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    textKey: PropTypes.string,
    valueKey: PropTypes.string,
    bestOffers: PropTypes.func.isRequired,
    resetOffers: PropTypes.func.isRequired,
    initialReset: PropTypes.func.isRequired,
    blackBookURL: PropTypes.string,
  };
  static defaultProps = {
    label: geti18n('personalizePanel.creditRating'),
    items: geti18n('personalizePanel.creditSelect'),
    textKey: 'text',
    valueKey: 'value',
    blackBookURL: geti18n('linkPaths.blackBookURL'),
  };
  constructor(props) {
    super(props);
    this.onSelect = this.onSelect.bind(this);
  }
  onSelect(rating) {
    const { select, bestOffers, resetOffers, initialReset } = this.props; //eslint-disable-line
    select(rating);
    initialReset();
  }
  render() {
    const { label, items, textKey, valueKey, value, blackBookURL } = this.props;
    return (
      <div className="credit-rating-row">
        <form>
          <span className="credit-rating-title">
            <p className="credit-rating-title-p">
              <TextLink url={blackBookURL} target="_blank" text={label} linkName="BLACKBOOK-LINK" classNames="credit-rating-title-link" />
            </p>
            <BBTextLink />
          </span>
          <SelectBox
            className="credit-rating-select"
            label={label}
            items={items}
            onSelect={this.onSelect}
            textKey={textKey}
            valueKey={valueKey}
            value={value}
            removeLabel
          />
        </form>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  value: get(state, 'userAmounts.creditRating')
});

const mapDispatchToProps = dispatch => ({
  select: bindActionCreators(updateCreditSelectAction, dispatch),
  bestOffers: bindActionCreators(getBestOfferActionFromState, dispatch),
  resetOffers: bindActionCreators(resetTermMileage, dispatch),
  initialReset: bindActionCreators(initialRenderReset, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CreditRatingSelect);



/** WEBPACK FOOTER **
 ** ./src/components/SelectBox/CreditRatingSelect/index.js
 **/